import React, { useState } from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../lib/auth';
import { Sidebar, MobileNav } from './Sidebar';
import { Toaster } from '../ui/sonner';

export const Layout = () => {
  const { isAuthenticated } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen bg-[#121212] flex">
      {/* Noise overlay for texture */}
      <div className="noise-overlay" />
      
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      
      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Mobile Header */}
        <MobileNav onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Page Content - With safe area padding for mobile navigation bar */}
        <main className="flex-1 p-4 md:p-6 lg:p-8 mt-16 md:mt-0 overflow-auto pb-24 md:pb-6 safe-area-bottom">
          <div className="max-w-7xl mx-auto animate-fadeIn">
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* Toast Notifications */}
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: '#1E1E1E',
            color: '#FFFFFF',
            border: '1px solid #3F3F46',
          },
        }}
      />
    </div>
  );
};

export default Layout;
